import React from "react";
import "./Footer.css";

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <p>&copy; 2025 Micaela. Built with React & TypeScript ❤️</p>
    </footer>
  );
};

export default Footer;
